<template>
  <b-modal id="sessionTimeout"
           ref="sessionTimeout"
           size="lg"
           title="Oops Something went wrong"
           :hide-footer="true"
           :no-close-on-backdrop="true">
    <b-row>
      <b-col lg="12" class="pr-5 pl-5">
        <p class="lead">Please reload the page.</p>
        <p class="mb-3 lead">There's been an error loading this report. Please refresh the page and if the issue persists please email:</p>
        <p class="lead text-center pt-3"><a :href="`mailto:${(report.hasOwnProperty('author')) ? report.author.email : ''}`"><strong>{{ (report.hasOwnProperty('author')) ? report.author.email : '' }}</strong></a></p>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import bus from '../../plugins/bus'
import { mapState } from 'vuex'
export default {
  name: 'SessionTimeoutModal',
  computed: {
    ...mapState({
      report: state => state.report.reportPreferences,
    }),
  },
  mounted () {
    bus.on('sessionTimeout', this.sessionTimeoutModal)
  },
  methods: {
    sessionTimeoutModal () {
      document.body.classList.add('blurred')
      this.$refs.sessionTimeout.show()
    },
  },
  beforeDestroy () {
    bus.off('sessionTimeout')
  },
}
</script>

<style>
  #sessionTimeout {
    font-family: "averta", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
  }
  #sessionTimeout .modal-title {
    font-size: 1.5rem;
  }
  #sessionTimeout .btn-primary { /* TODO: This is a global style */
    color: #fff;
    background-color: #112130;
    border-color: #112130;
  }
  #sessionTimeout .modal-dialog {
    max-width: 35%!important;
    /*margin-top: 7rem;*/
  }
  @media screen and (max-width: 575px){
    #sessionTimeout .modal-dialog {
      max-width: 95%!important;
      margin: 10% auto 0 auto;
    }
  }
  #sessionTimeout button {
   display: none;
  }
  #sessionTimeout .lead {
    color: #85868a;
    font-family: Roboto,sans-serif;
    font-size: 1.25rem;
    font-weight: 300;
  }
</style>
